const state = {
  listaEventManagers: [],
  eventManager: {
    id: null,
    evento: { id: null },
    responsavel: { id: null },
    ativo: true,
  },
}

export default state
